import dayjs, { Dayjs } from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(isBetween);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

// These are functions (instead of constants) to avoid stale values
// (e.g., if the `currentYear` constant was evaluated at 12/31/2020 23:59:59,
// it would give us the wrong year on 1/1/2021)
export const currentYear = (): number => dayjs.utc().get('year');

export const get1stDayNextQuarter = (): Dayjs => {
  const currentDate = dayjs.utc();
  const thisYear = currentDate.get('year');
  const APRIL_1 = dayjs.utc(`${thisYear}-04-01`);
  const JULY_1 = dayjs.utc(`${thisYear}-07-01`);
  const OCT_1 = dayjs.utc(`${thisYear}-10-01`);
  let firstQuarterDateCreditWillApply = dayjs.utc(`${thisYear + 1}-01-01`);
  if (currentDate.isBefore(APRIL_1)) {
    firstQuarterDateCreditWillApply = APRIL_1;
  } else if (currentDate.isBefore(JULY_1)) {
    firstQuarterDateCreditWillApply = JULY_1;
  } else if (currentDate.isBefore(OCT_1)) {
    firstQuarterDateCreditWillApply = OCT_1;
  }
  return firstQuarterDateCreditWillApply;
};

export const daysBetweenDate = (startDate: Date, endDate: Date): number => {
  const MILLIS_IN_DAY = 1000 * 3600 * 24;
  return (endDate.getTime() - startDate.getTime()) / MILLIS_IN_DAY;
};

export const formatDate = (date: string): string => dayjs(date).format('MM/DD/YY');

/**
 * How every data-source and connection table renders a timestamp. One place, because the three
 * tables that show one sit next to each other on the same pages and reading two different formats
 * across them looks like a bug.
 */
export const formatDateTime = (date: string | Date): string => dayjs(date).format('MM/DD/YY hh:mm A');
